/**
 * Strips the function host key out of anything that may be shown to a user or
 * written to a log. Requests send the key as the `x-functions-key` header, but a
 * URL that still carries `?code=<key>` - an endpoint override written the old way -
 * would otherwise hand the key to whoever reads the screen.
 */
export function redactFunctionKey(text: string): string {
  return text.replace(/([?&]code=)[^&\s]+/gi, "$1***");
}
